/**
 * Base URL of the optional companion API.
 *
 * The validator itself never talks to a server: the photo is validated locally
 * and never uploaded. The only remaining consumer of this address is anonymous
 * aggregate analytics (see `events.ts`), which is disabled when the variable is
 * empty. `apps/api` still exposes `/api/v1/validate` for white-label and
 * server-side integrations, but the browser validator does not call it.
 */

export const apiBase = (): string => (import.meta.env.VITE_VALIDATOR_API_BASE ?? '').replace(/\/$/, '');
